<app-background-card
  title="{{ 'common.selecthor.admin.provider.invoice.list.title' | transloco }}"
  titleTestId="provider-list-header"
  testId="provider-list-card"
>
  @if (loading()) {
    <app-loading />
  } @else {
    <p-table
      #dt
      [value]="invoiceRows()"
      [rows]="10"
      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'common.table.currentPageReportTemplate' | transloco }}"
      [responsiveLayout]="'scroll'"
      [globalFilterFields]="globalFilterFields"
      [loading]="loading()"
      class="p-datatable-striped"
      data-testid="provider-list-table"
    >
      <ng-template #caption>
        <div class="flex justify-end">
          <app-global-search (searchValue)="dt.filterGlobal($event, 'contains')" />
        </div>
      </ng-template>

      <ng-template #header>
        <tr>
          @for (col of columns; track col.field) {
            <th
              [pSortableColumn]="col.sortableColumn"
              [attr.data-testid]="col.testId + '-header'"
              [style.width]="col.columnWidth"
              scope="col"
            >
              {{ col.headerKey | transloco }}
              @if (col.sortableColumn) {
                <p-sortIcon [field]="col.field"></p-sortIcon>
              }
              @if (col.filterable) {
                <app-table-column-filter [field]="col.field" />
              }
            </th>
          }
        </tr>
      </ng-template>

      <ng-template #body let-invoice>
        <tr data-testid="provider-list-row">
          @for (col of columns; track col.field) {
            <td [attr.data-testid]="col.testId + '-cell'">
              @switch (col.field) {
                @case ('invoiceNumber') {
                  <span class="font-medium">{{ invoice.invoiceNumber }}</span>
                }
                @case ('invoiceDate') {
                  <span>{{ invoice.invoiceDate | appDate }}</span>
                }
                @case ('dueDate') {
                  <span>{{ invoice.dueDate | appDate }}</span>
                }
                @case ('invoiceAmount') {
                  <span>{{ invoice.invoiceAmount }} {{ invoice.currency }}</span>
                }
                @case ('status') {
                  <span>{{ invoice.status }}</span>
                }
                @case ('provider') {
                  <span>{{ invoice.provider }}</span>
                }
                @case ('plan') {
                  <span>{{ invoice.plan }}</span>
                }
                @case ('description') {
                  <span>{{ invoice.description }}</span>
                }
                @case ('actions') {
                  <div class="flex gap-2 justify-center">
                    <p-button
                      icon="pi pi-pencil"
                      [rounded]="true"
                      [text]="true"
                      severity="secondary"
                      (onClick)="editInvoice(invoice.originalData)"
                      data-testid="edit-invoice-btn"
                    />
                    <p-button
                      icon="pi pi-download"
                      [rounded]="true"
                      [text]="true"
                      severity="primary"
                      (onClick)="downloadInvoice(invoice.originalData)"
                      data-testid="download-invoice-btn"
                    />
                    <p-button
                      icon="pi pi-trash"
                      [rounded]="true"
                      [text]="true"
                      severity="danger"
                      (onClick)="deleteInvoice(invoice.originalData)"
                      [attr.data-testid]="'delete-invoice-' + invoice.invoiceNumber"
                    ></p-button>
                  </div>
                }
              }
            </td>
          }
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="columns.length"><app-no-data /></td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex justify-end gap-2 mt-6">
      <p-button
        [label]="'selecthorAdmin.provider.invoices.create.button' | transloco"
        styleClass="px-8! text-sm! uppercase"
        data-testid="save-changes-button"
        (onClick)="viewInvoiceData()"
      ></p-button>
    </div>
  }
</app-background-card>

<app-provider-invoice-upload-dialog
  [(visible)]="createInvoiceDialogVisible"
  [invoice]="selectedInvoice()"
  (invoiceSaved)="onInvoiceSaved()"
/>
